<template>
  <span>
    <img
      v-if="lang === 'pt'" 
      :width="width"
      src="@/assets/img/flags/pt.svg"
    >
    <img
      v-if="lang === 'pt_br'" 
      :width="width"
      src="@/assets/img/flags/pt-br.svg"
    >
    <img
      v-if="lang === 'en'"
      :width="width" 
      src="@/assets/img/flags/en.svg"
    >
  </span>
</template>
<script>
  export default {
    name: 'FlasImages',
    props: {
      lang: {
        type: String,
        default: 'eng'
      },
      width: {
        type: String,
        default: 'eng'
      }
    },
  }
</script>